module.exports = {
  apiKey: '914c1f240d851d967f42eb124ee673e71a9131d3',
  apiUrl: 'https://staging.api.moank.se/api',
  appUrl: 'https://staging.app.moank.se',
  sentryUrl: 'https://1069016f2014bdcf7196a3f02394e344@o111207.ingest.sentry.io/4505630226382853',
  environment: 'staging',
};
